// ESM-Huelle um lib/scripts/pos/CLS_CBunchOps.js (Phase 4, Welle 3) -
// Strauss-Sonderprodukte, eines der sechs beim BonManager-Refactor extrahierten
// Module (Prototype-Mixin, wird im CBonManager-Konstruktor an die
// Instanz gebunden). Prototype-Stil bleibt vorerst.
function CBunchOps() {}

CBunchOps.prototype.productExpiration = function () {
    var BonManagerClass = this;
    $.when(Trans.remakeInStock(this.currentBonId, "EXP")).then(function () {
        Trans.closeBon(BonManagerClass.currentBonId, "EXP");
        BonManagerClass.reset();
    });
}

CBunchOps.prototype.productRecovery = function () {
    var BonManagerClass = this;
    $.when(Trans.remakeInStock(this.currentBonId, "IEX")).then(function () {
        Trans.closeBon(BonManagerClass.currentBonId, "IEX");
        BonManagerClass.reset();
    });
}

CBunchOps.prototype.productChange = function (prodId, prodQty, newProdId) {
    Trans.addMPREntry(this.currentBonId, newProdId, prodQty);
    var BonManagerClass = this;
    $.when(Trans.remakeInStock(this.currentBonId, "MPR")).then(function () {
        Trans.closeBon(BonManagerClass.currentBonId, "MPR");
        BonManagerClass.reset();
    });
}

CBunchOps.prototype.separateBunch = function (bunchId) {
    var BonManagerClass = this;
    $.when(Trans.getLastBFC(bunchId)).then(function (lastBFCBon) {
        $.when(Trans.closeBon(BonManagerClass.currentBonId, "BFS")).done(function () {
            BonManagerClass.reset();
            $.when(Trans.openBon()).then(function (newBonId) {
                $.when(Trans.separateBunchEntry(lastBFCBon, newBonId)).then(function () {
                    $.when(Trans.copyLastBFC(lastBFCBon, newBonId)).then(function () {
                        $.when(BonManagerClass.loadFromId(newBonId)).done(function () {
                            Trans.remakeInStock(BonManagerClass.currentBonId, "BFS");
                        });
                    });
                });
            });
        });
    });
}

CBunchOps.prototype.isBunchWorkPresent = function () {
    for (var i in this.currentBon) {
        if (!this.currentBon[i].cancelled && this.currentBon[i].type == "POS" &&
            this.currentBon[i].text1 == "Floristikbeiwerk")
            return true;
    }

    return false;
}

CBunchOps.prototype.addNewBunch = function (sum, bunchType, qty) {
    var text,
    textScanner;
    var BonManagerClass = this;
    sum = parseFloat(sum);
    this.bunchSum = sum;
    this.bunchType = bunchType;
    this.bunchQty = qty;
    var hasBunchWorkIncluded = false;

    var def1 = $.Deferred();
    //check if POS == bunch  --->   replace bunch by its POS
    var iterator = function it(i) {
        if (i < BonManagerClass.currentBon.length) {
            if ((BonManagerClass.currentBon[i].productId > 1000000000) && (BonManagerClass.currentBon[i].type != "BFS") && (!BonManagerClass.currentBon[i].cancelled)) { //ist Strauss?
                var Id = BonManagerClass.currentBon[i].productId;
                $.when(Trans.getLastBFC(Id)).then(function (lastBFCBon) {
                    if (lastBFCBon > 0) {
                        $.when(Trans.copyLastBFC(lastBFCBon, BonManagerClass.currentBonId)).then(function () {
                            BonManagerClass.cancelEntry(BonManagerClass.currentBon[i]);
                            hasBunchWorkIncluded = true;
                            iterator(i + 1);
                        });

                    } else {
                        iterator(i + 1);
                    }
                });
            } else {
                iterator(i + 1);
            }
        } else {

            def1.resolve();
            return;
        }
    }
    iterator(0);
    // end check

    if (BonManagerClass.currentBon[0].type == "BFS") {
        hasBunchWorkIncluded = true;
    }

    $.when(def1).then(function () {

        if ((bunchType == "Geschenkstrau&szlig;" || bunchType == "Geschenktopf" ||
                bunchType == "Biedermeierstrau&szlig;") && (!hasBunchWorkIncluded)) {
            var def10 = $.Deferred();
            if (bunchType == "Geschenkstrau&szlig;" && !BonManagerClass.isBunchWorkPresent()) {
                BonManagerClass.dontSendScanner = true;
                $.when(Trans.getAdditionalBunchWork()).then(function (val) {
                    $.when(BonManagerClass.preAddEntryPOS(1, val)).done(function () {
                        BonManagerClass.dontSendScanner = false;
                        BonManagerClass.bunchSum += 1;
                        sum += 1;
                        def10.resolve();
                    });
                });

            } else {
                def10.resolve();
            }
            $.when(def10).then(function () {
                var ThresholdPrice = new CThresholdPrice(BonManagerClass.currentBon, BonManagerClass.currentBonId);

                var prices = ThresholdPrice.getThresholdPricesSV();

                var foundPrice = ThresholdPrice.checkThresholdPriceSV(prices, sum);

                if (foundPrice) {
                    var text = POS.lang.getText("MESSAGES", "WARNING_THRESHOLD_1") +
                        " " + bunchType + " " + POS.lang.getText("MESSAGES", "WARNING_THRESHOLD_2") +
                        " " + foundPrice + " " + POS.lang.getText("MESSAGES", "WARNING_THRESHOLD_3") +
                        " " + bunchType + " " + POS.lang.getText("MESSAGES", "WARNING_THRESHOLD_4");
                    if (BonManagerClass.Main.UID == POS.sessions.currentSession)
                        POS.message.show(text, "warning", "YESNO", BonManagerClass, BonManagerClass.doAddNewBunch);
                    else
                        POS.message.save(BonManagerClass.Main.UID, text, "warning", "YESNO", BonManagerClass, BonManagerClass.doAddNewBunch);

                } else
                    BonManagerClass.doAddNewBunch(BonManagerClass, "NO");
            }); //def10
        } else
            BonManagerClass.doAddNewBunch(BonManagerClass, "NO");
    });
}

CBunchOps.prototype.doAddNewBunch = function (me, result) {

    if (result == "YES") {
        // Der Funkscanner ist am 26.8.2026 entfallen; hier stand sein
        // sendMessage("OK"). Das return gehoert NICHT dazu - es bricht den
        // Ablauf ab, wenn der Benutzer die Rueckfrage bejaht.
        return;
    }

    var sum = me.bunchSum;
    var type = me.bunchType;
    var qty = me.bunchQty;
    if (!qty)
        qty = 1;

    var refBon = me.currentBonId;
    var def = $.Deferred();

    var currentBonId = null;
    var bunchbarcode = null;

    var iterator = function it(i) {
        if (i < qty) {
            $.when(Trans.remakeInStock(me.currentBonId, "BFC")).then(function () {
                $.when(Trans.addBunch(me.currentBonId, sum, type)).then(function (barcode) {
                    $.when(me.printBarcode(barcode, sum, type)).then(function () {
                        currentBonId = me.currentBonId; //for slaves
                        bunchbarcode = barcode;
                        me.reset();
                        if (i + 1 < qty) {
                            $.when(Trans.openBon()).then(function (newBonId) {
                                $.when(Trans.copyLastBFC(refBon, newBonId)).then(function () {
                                    $.when(me.loadFromId(newBonId)).done(function () {
                                        iterator(i + 1);
                                        return;
                                    });

                                });
                            });

                        } else {
                            iterator(i + 1);
                            return;
                        }
                    });
                });
            });
        } else {
            def.resolve();
            return;
        }
    }
    iterator(0);

    $.when(def).done(function () {

        //copy to remote Slaves

        if (POS.otherPOS && POS.otherPOS.length > 1 && POS.POSType == "Master") {
            var userid = POS.sessions.currentSession;
            var sql = "SELECT * FROM BONE WHERE BON_ID = " + currentBonId +
                " AND Cancelled = 0 AND Type != 'BFS'";
            $.when(POS.SQLiteCon.execute(sql)).then(function (BFFBon) {

                for (var i = 0; i < POS.otherPOS.length; i++) {
                    if (POS.otherPOS[i].Type != "Master") {
                         var data = {
                            "host": POS.otherPOS[i].address,
                            "port": 9000,
                            "data": "addbunch " + JSON.stringify({
                                "bfcs":
                                [{
                                        "userid": userid,
                                        "bon": BFFBon,
                                        "prod": {
                                            "sum": sum,
                                            "bunchtype": type,
                                            "qty": qty,
                                            "barcode": bunchbarcode
                                        }
                                    }
                                ]
                            })
                        }
                        var url = "request.php";
                        $.when(new CRunClient().sendDataAsync(null, null, null, null, 0, null, url, data)).then(function (data, error) {
                            if (data) {}
                            else if (error) {
                                log.add(4, "Fail", "Bunches could not be sent!");
                            }
                        });

                    } //if
                } //for
            }); //when
        } //if

    });
}

CBunchOps.prototype.isBonStillNew = function (bonId) {
    var dfd = jQuery.Deferred();
    $.when(Trans.isBonStillNew(bonId)).then(function (val) {
        if (val) {
            dfd.resolve(true);
        } else {
            dfd.resolve(false);
        }
    });
    return dfd.promise();
}

export { CBunchOps };
